var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisaSponsorship(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 1H3v14h8.667c.736 0 1.333-.627 1.333-1.4V2.4c0-.773-.597-1.4-1.333-1.4z",
    stroke: "#AEBECA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.667 7A.333.333 0 1 1 5 7a.333.333 0 0 1 .667 0zM6.35 5.35a.333.333 0 1 1-.471-.471.333.333 0 0 1 .471.471zM11 7a.333.333 0 1 1-.667 0A.333.333 0 0 1 11 7zM10.121 9.121a.333.333 0 1 1-.471-.471.333.333 0 0 1 .471.471zM8.333 4.333a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0zM10.121 5.35a.333.333 0 1 1-.471-.471.333.333 0 0 1 .471.471zM8.333 9.667a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0zM6.35 9.121a.333.333 0 1 1-.471-.471.333.333 0 0 1 .471.471zM6 12h4",
    stroke: "#AEBECA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaSponsorship);
export default __webpack_public_path__ + "static/media/visa-sponsorship.557c868b.svg";
export { ForwardRef as ReactComponent };